export default __webpack_public_path__ + "/dist/images/download.247bd644a114f6c82759a314e67a15ef.svg";